import {
    Badge,
    Box,
    Button,
    JsonInput,
    Stack,
    Text,
    Tooltip,
} from '@mantine/core';
import { forwardRef, useEffect, useRef } from 'react';

const JsonOptionsCell = ({ cell, accessorKey, onClick }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const options = rowData[accessorKey] || {};

    if (!onClick) {
        return (
            <Tooltip
                p={0}
                label={
                    <JsonInput
                        value={JSON.stringify(options)}
                        formatOnBlur
                        autoFocus
                        autosize
                    />
                }>
                <Badge
                    size={'xs'}
                    color={'gray'}
                    onClick={() => onClick(accessorKey, options)}>
                    Hover
                </Badge>
            </Tooltip>
        );
    }
    return (
        <Button
            size={'compact-xs'}
            color={'blue'}
            onClick={() => onClick(accessorKey, options)}>
            Click
        </Button>
    );
};

const JsonOptionsColumn = ({ accessorKey, header, id, onClick }) => ({
    id: id ?? accessorKey,
    accessorKey: accessorKey,
    header: header,
    size: 1,
    Cell: ({ cell }) => {
        return (
            <JsonOptionsCell
                cell={cell}
                accessorKey={accessorKey}
                onClick={onClick}
            />
        );
    },
});
export default JsonOptionsColumn;
